import { gql } from '@apollo/client';

export const COMMISSION_PAYLOAD = gql`
    fragment CommissionFragment on Commission {
        _id
        name
    }
`;

export const getCommissionsQuery = gql`
    query getCommissions {
        commissions: getCommissions {
            ...CommissionFragment
        }
    }
    ${COMMISSION_PAYLOAD}
`;

export const ADD_COMMISSION_PRO = gql`
  mutation addCommissionPro($name: String!, $order: Int) {
    data: addCommissionPro(name: $name, order: $order) {
      _id
      name
      category
      status
      order
    }
  }
`;

export const DELETE_COMMISSION_PRO = gql`
  mutation deleteCommissionPro($id: ID!) {
    deleteCommissionPro(id: $id)
  }
`;
